import React from 'react';
import { CardContent, CardHeader, CardTitle } from './Card';
import { AlertCircle } from 'lucide-react';
import Modal from './Modal';

const ErrorDialog = ({ isOpen, onClose, title = 'Error', message }) => {
  const displayMessage = typeof message === 'string' ? message : (message != null ? JSON.stringify(message) : '');

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="w-full max-w-md mx-4">
      <CardHeader className="pr-10">
        <CardTitle className="flex items-center text-red-600">
          <AlertCircle className="h-5 w-5 mr-2" />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-gray-700 whitespace-pre-line break-words [overflow-wrap:anywhere] max-h-64 overflow-y-auto">
          {displayMessage}
        </p>
      </CardContent>
    </Modal>
  );
};

export default ErrorDialog;
